var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4L15 7M12 15V4V15ZM12 4L9 7L12 4Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.5H8C7.01367 19.5 6.69515 19.4953 6.45248 19.4569C4.95485 19.2197 3.78029 18.0451 3.54309 16.5475C3.50466 16.3048 3.5 15.9863 3.5 15C3.5 14.0137 3.50466 13.6952 3.54309 13.4525C3.78029 11.9549 4.95485 10.7803 6.45248 10.5431C6.69515 10.5047 7.01367 10.5 8 10.5H8.25C8.66421 10.5 9 10.1642 9 9.75C9 9.33579 8.66421 9 8.25 9H8C7.07099 9 6.60649 9 6.21783 9.06156C4.07837 9.40042 2.40042 11.0784 2.06156 13.2178C2 13.6065 2 14.071 2 15C2 15.929 2 16.3935 2.06156 16.7822C2.40042 18.9216 4.07836 20.5996 6.21783 20.9384C6.60649 21 7.07099 21 8 21H16C16.929 21 17.3935 21 17.7822 20.9384C19.9216 20.5996 21.5996 18.9216 21.9384 16.7822C22 16.3935 22 15.929 22 15C22 14.071 22 13.6065 21.9384 13.2178C21.5996 11.0784 19.9216 9.40042 17.7822 9.06156C17.3935 9 16.929 9 16 9H15.75C15.3358 9 15 9.33579 15 9.75C15 10.1642 15.3358 10.5 15.75 10.5H16C16.9863 10.5 17.3048 10.5047 17.5475 10.5431C19.0451 10.7803 20.2197 11.9549 20.4569 13.4525C20.4953 13.6952 20.5 14.0137 20.5 15C20.5 15.9863 20.4953 16.3048 20.4569 16.5475C20.2197 18.0451 19.0451 19.2197 17.5475 19.4569C17.3048 19.4953 16.9863 19.5 16 19.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.bedaea709853bed20557699024b0e2b2.svg";
export { ForwardRef as ReactComponent };